import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(1),
  },
  bar: {
    height: 10,
    borderRadius: 3,
    marginTop: theme.spacing(1),
  },
}));

// Barra única do import de lista: envio da planilha → importação → validação.
// `value` null = indeterminada (etapa sem total conhecido, ex.: fila).
const ContactListImportProgress = ({ label, value }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.root} variant="outlined">
      <Typography variant="body2">{label}</Typography>
      <LinearProgress
        className={classes.bar}
        variant={value === null ? "indeterminate" : "determinate"}
        value={value === null ? undefined : Math.min(100, Math.max(0, value))}
      />
    </Paper>
  );
};

export default ContactListImportProgress;
